export var PaymentStatuses;
(function (PaymentStatuses) {
    PaymentStatuses["payPending"] = "pay_pending";
    PaymentStatuses["paySuccess"] = "pay_success";
    PaymentStatuses["forReupload"] = "for_reupload";
    PaymentStatuses["forConfirmation"] = "for_confirmation";
})(PaymentStatuses || (PaymentStatuses = {}));
